import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { SearchResultPage } from '@damofire/data-commons';

export interface GridPaginatorPreferences {
  itemsPerPage: number;
  itemsPerPageChoices: number[];
  showFirstLastButtons: boolean;
  hidePageSize: boolean;
}

const DEFAULT_PREFS: GridPaginatorPreferences = {
  itemsPerPage: 25,
  itemsPerPageChoices: [25, 50, 75, 100],
  showFirstLastButtons: true,
  hidePageSize: false,
};

@Component({
  selector: 'app-grid-paginator',
  templateUrl: './grid-paginator.component.html',
  standalone: true,
  imports: [MatPaginatorModule],
  styleUrls: ['./grid-paginator.component.scss'],
})
export class GridPaginatorComponent {
  @Input()
  id = 'paginator';

  @Input()
  searchResultPage: SearchResultPage = {};

  private _preferences: GridPaginatorPreferences = { ...DEFAULT_PREFS };

  @Output()
  page: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  @ViewChild('paginator')
  paginator: MatPaginator;

  @Input()
  set preferences(p: Partial<GridPaginatorPreferences>) {
    this._preferences = { ...DEFAULT_PREFS, ...p };
  }

  get preferences(): GridPaginatorPreferences {
    return this._preferences;
  }

  get pageIndex(): number {
    return this.paginator?.pageIndex || 0;
  }

  set pageIndex(index: number) {
    this.paginator.pageIndex = index;
  }

  pageOptsUpdated(event: PageEvent): void {
    this.page.next(event);
  }

  @HostListener('window:keyup.Home', ['$event'])
  firstPage(): void {
    this.paginator.firstPage();
  }

  @HostListener('window:keyup.End', ['$event'])
  lastPage(): void {
    this.paginator.lastPage();
  }

  @HostListener('window:keyup.PageUp', ['$event'])
  @HostListener('window:keyup.ArrowRight', ['$event'])
  nextPage(): void {
    this.paginator.nextPage();
  }

  @HostListener('window:keyup.PageDown', ['$event'])
  @HostListener('window:keyup.ArrowLeft', ['$event'])
  previousPage(): void {
    this.paginator.previousPage();
  }
}
